import { Card, CardBody, Button, CardHeader } from '@heroui/react';
import { Icon } from '@iconify/react';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getImageNumber } from '@/patient-app-common/helpers/survey_helper';

export function QuestionAnswer({ answers, handleEdit, questions }) {
  const { t } = useTranslation('survey');

  const getQuestionAnswer = questions.map((question, i) => {
    if (!_.has(answers, `q${i + 1}`)) {
      return null;
    }

    let answer;
    switch (question.type) {
      case 'camera':
        answer = t('common.text.no_entry');

        if (answers[question.id]) {
          answer = (
            <img
              alt={t('common.text.attachment')}
              width="150px"
              src={URL.createObjectURL(answers[question.id])}
            />
          );
        }
        break;

      case 'checkbox':
        answer = [];
        answers[question.id].forEach(
          (value, i) =>
            value &&
            answer.push(
              <li key={question.answers[i].text} className="ml-2">
                {question.answers[i].text}
              </li>
            )
        );
        break;

      case 'device':
        break;

      case 'face_scale':
        answer = `${
          answers[question.id] * 2
        } - ${t(`facescale.value_${answers[question.id]}`)}`;
        break;

      case 'gen_scale':
      case 'radio':
        answer = question.answers[answers[question.id]].text;
        break;

      case 'medicine':
        answer = [];
        answers[question.id].forEach(
          (value, i) =>
            !_.isEmpty(value) &&
            answer.push(
              <li key={question.answers[i].text} className="ml-2">
                {`${question.answers[i].text} ${value.dose} - ${value.pills} pills`}
              </li>
            )
        );
        break;

      case 'numerical_input':
        answer = answers[question.id];
        break;

      case 'picker':
        answer = t('picker.selected_hint', {
          answer: getImageNumber(question.answers[answers[question.id]].text),
        });
        break;

      case 'multiple_numerical_input':
        answer =
          answers[question.id].join('/') + ` ${question.options.unit || ''}`;
        break;

      default:
        answer = answers[question.id] || t('common.text.no_entry');
    }

    return (
      <Card key={i} shadow="sm">
        <CardHeader className="justify-between">
          <h3 className="font-semibold">{question.title}</h3>
          <Button
            color="primary"
            endContent={<Icon icon="mdi:edit" />}
            onPress={() => handleEdit(i)}
            variant="bordered"
          >
            {t('common.action.edit')}
          </Button>
        </CardHeader>
        <CardBody className="pt-0">
          <p className="pb-4 whitespace-pre-wrap">{answer}</p>
        </CardBody>
      </Card>
    );
  });

  return <>{getQuestionAnswer}</>;
}
